<template>
  <Dialog :open="open" :close-on-overlay-click="false" @update:open="onOpenChange">
    <template #header>
      <h2 class="text-2xl-medium text-black-white">
        {{ t('setting.device.firmware.boot.pickOwner.title') }}
      </h2>
    </template>

    <div class="text-text-glass-default text-sm leading-relaxed space-y-3">
      <p>{{ t('setting.device.firmware.boot.pickOwner.body1') }}</p>
      <p>{{ t('setting.device.firmware.boot.pickOwner.body2') }}</p>
      <div class="flex flex-col gap-2 pt-1">
        <Button
          v-for="model in models"
          :key="model"
          :variant="selected === model ? 'fill' : 'wireframe'"
          class="w-full justify-center"
          @click="selected = model"
        >
          {{ model }}
        </Button>
      </div>
    </div>

    <template #footer>
      <div class="flex w-full gap-3">
        <Button class="flex-1" color="text-b-w" @click="onCancel">{{ t('common.cancel') }}</Button>
        <Button class="flex-1" color="black" :disabled="!selected" @click="onConfirm">
          {{ t('common.confirm') }}
        </Button>
      </div>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
  import { ref } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { Button, Dialog } from '@rapoo/element'

  const props = defineProps<{
    models: string[]
  }>()

  const emit = defineEmits<{
    confirm: [model: string]
    cancel: []
  }>()

  const { t } = useI18n()
  const open = ref(true)
  const selected = ref(props.models[0] ?? '')

  function onConfirm() {
    if (!selected.value) return
    open.value = false
    emit('confirm', selected.value)
  }

  function onCancel() {
    open.value = false
    emit('cancel')
  }

  function onOpenChange(next: boolean) {
    if (next) return
    emit('cancel')
  }
</script>
